export default "__VITE_ASSET__DyxLc_Fk__"